import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const EventContext = createContext({ event: null, loading: true, refresh: () => {} });

export const EventProvider = ({ children }) => {
  const [event, setEvent] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async (attempt = 0) => {
    try {
      const { data } = await api.get("/event", { timeout: 15000 });
      setEvent(data);
      document.title = data.tab_title;
      const root = document.documentElement.style;
      root.setProperty("--accent", data.accent);
      root.setProperty("--accent-2", data.accent_secondary);
      root.setProperty("--accent-soft", data.accent_soft);
      setLoading(false);
    } catch (e) {
      console.error("event config failed", e);
      if (attempt < 6) setTimeout(() => refresh(attempt + 1), 1500 * (attempt + 1));
      else setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return <EventContext.Provider value={{ event, loading, refresh }}>{children}</EventContext.Provider>;
};

export const useEvent = () => useContext(EventContext);
